/**
 * 전략 관련 UI 문자열 리소스
 * strategy-view, strategy-panel 등에서 사용
 */
export const strategyStr = {
  error: {
    /** 사용 중인 전략 삭제 불가 */
    cannotDeleteInUse: '[{name}]은 사용 중인 전략이므로 삭제할 수 없습니다.',
    /** 사용 중인 전략 삭제 불가 (이름 없음) */
    cannotDeleteInUseSimple: '사용 중인 전략이므로 삭제할 수 없습니다.',
    /** 중복된 조건식 분류명 */
    duplicateCategoryName: '이미 존재하는 조건식 분류명입니다.',
    /** 신호 무시 실패 */
    ignoreSignalFailed: '신호 무시 실패: {error}',
  },
  panel: {
    addSignalType: '신호 타입 추가',
  },
  saveConfirmation: {
    title: '변경사항이 있습니다',
    content: '저장하지 않은 변경사항이 있습니다. 저장하시겠습니까?',
    save: '저장',
    discard: '폐기',
    cancel: '취소',
  },
  creatorTab: {
    /** 메인 툴바 전략명 Input placeholder (SubTask 24) */
    namePlaceholder: '전략명을 입력해 주세요',
    /** 빈 이름 시 입력란/저장 버튼 tooltip (SubTask 24) */
    nameRequired: '전략명을 입력해 주세요',
  },
  filter: {
    strategyName: '전략명',
    summary: '개요',
    selectData: '데이터 선택',
    dataLabel: '{label} 데이터',
  },
  signalType: {
    tab: {
      condition: '조건',
      reference: '참조',
    },
    header: {
      name: '이름',
      description: '설명',
      action: '작업',
    },
    button: {
      addSignal: '+ 신호',
    },
    popup: {
      selectAction: '동작 선택',
    },
    message: {
      confirmDeleteSignalType: '{name} 신호 타입을 삭제하시겠습니까?',
      noSelectedSignalType: '선택된 신호 타입이 없습니다.',
      confirmDropAction: '[{names}] 조건을 [{target}](으)로 {action}하시겠습니까?',
      dropActionSuccess: '[{names}] 조건을 [{target}](으)로 {action}했습니다.',
    },
    dialog: {
      addTitle: '신호 타입 추가',
      editTitle: '신호 타입 수정',
    },
    form: {
      id: 'ID',
      name: '이름',
      description: '설명',
    },
    validation: {
      enterName: '이름을 입력하세요',
    },
  },
  indicator: {
    header: {
      name: '이름',
      timeframe: 'Timeframe',
      inputs: '입력값',
      action: '작업',
    },
    form: {
      timeframe: '시간 캔들',
      timeframeRequired: '시간 캔들을 선택하세요',
    },
    dialog: {
      deleteTimeframeTitle: 'Timeframe 삭제',
      deleteTimeframeIndicators: '다음 지표들이 삭제됩니다:',
      deleteTimeframeConditions: '다음 조건들도 함께 삭제됩니다:',
    },
  },
  condition: {
    header: {
      name: '이름',
      group: '그룹',
      timeframe: 'Timeframe',
      operand1: '항목',
      operator: '조건',
      operand2: '비교 항목',
      options: '내용',
      action: '작업',
    },
    button: {
      changeTimeframe: '봉 변경',
      changeOperator: '조건 변경',
      enableCondition: '조건 사용',
      disableCondition: '사용 안 함',
    },
    offset: {
      byCandle: '캔들 오프셋 사용',
      byValue: '값 오프셋 사용',
    },
    tooltip: {
      dragToOtherSignalType: '드래그하여 다른 신호 타입으로 복사/이동/공유',
    },
    options: {
      consecutiveMin: '연속 {min}회 이상',
      consecutiveMax: '~ 연속 {max}회 이하',
    },
    message: {
      noSelectedCondition: '선택된 조건이 없습니다.',
    },
    form: {
      symbol: '종목',
      symbolPlaceholder: '예: BTC/USDT:USDT (선택 시 이 종목에만 적용)',
      symbolTooltip: '도형이나 웹훜을 사용하는 조건은 특정 종목 전용입니다',
      optional: '(선택)',
    },
    operand: {
      shapeIdFormat: '(id{id})',
    },
  },
  reference: {
    header: {
      baseAsset: '기준 자산',
      targetTrend: '참조 추세',
      currentTrend: '현추세',
    },
    title: '추세 참조 자산 목록',
    button: {
      addReference: '+ 참조',
    },
  },
  editMode: {
    add: '추가 : {count}개',
    edit: '수정 : {count}개',
    delete: '삭제 : {count}개',
  },
  label: {
    selected: '선택된',
  },
};
